(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (reducedMotion.matches) return;

  const tracks = document.querySelectorAll('[data-ticker-track]');
  if (!tracks.length) return;

  const SPEED = 25;
  const MULTIPLIER = 3;

  const raf2 = (fn) => requestAnimationFrame(() => requestAnimationFrame(fn));

  const setupTrack = (track) => {
    const viewport =
      track.closest('.announcement-ticker__viewport') ||
      track.parentElement; 

    const set = track.querySelector('[data-ticker-set]'); 

    const clearClones = () => {
      track.querySelectorAll('[data-ticker-clone="1"]').forEach((n) => n.remove());
    };

    const restartAnimation = () => {
      track.style.animation = 'none';
      track.offsetHeight;
      track.style.animation = '';
    };

    const applyDistanceAndDuration = (distancePx) => {
      if (!distancePx || distancePx < 1) return false;

      track.style.setProperty('--ticker-distance', `${distancePx}`);

      const duration = Math.max(10, distancePx / SPEED);
      track.style.setProperty('--ticker-duration', `${duration}s`);

      restartAnimation();
      return true;
    };

    const rebuild = () => {
      const viewportWidth = Math.round(viewport.getBoundingClientRect().width);

      if (set) {
        clearClones();

        const setWidth = Math.round(set.scrollWidth);
        if (!viewportWidth || !setWidth) return false;

        const targetWidth = viewportWidth * MULTIPLIER;
        let total = setWidth;

        while (total < targetWidth) {
          const clone = set.cloneNode(true);
          clone.setAttribute('data-ticker-clone', '1');
          track.appendChild(clone);
          total += setWidth;
        }

        return applyDistanceAndDuration(setWidth);
      }

      const total = Math.round(track.scrollWidth);
      if (!total) return false;

      const loop = Math.round(total / 2);
      return applyDistanceAndDuration(loop);
    };

    const rebuildWithRetries = () => {
      let tries = 0;
      const maxTries = 12;

      const attempt = () => {
        tries += 1;
        const ok = rebuild();
        if (!ok && tries < maxTries) raf2(attempt);
      };

      raf2(attempt);
    };

    rebuildWithRetries();
    window.addEventListener('resize', rebuildWithRetries, { passive: true });
    window.addEventListener('load', rebuildWithRetries, { passive: true });

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(rebuildWithRetries).catch(() => {});
    }
  };

  tracks.forEach(setupTrack);
})();